import ApiService from "@/common/api/api.service";
import helpers from "@/common/utils/helpers";

const UsuarioService = {
  listar(empresaId, porPagina = 0, pagina = 0) {
    return ApiService.get(`Usuario?EmpresaId=${empresaId}&TamanhoDaPagina=${porPagina}&NumeroDaPagina=${pagina}`);
  },
  buscarPorId(id) {
    return ApiService.get(`Usuario/${id}`);
  },
  salvar(form) {
    form.cnpj = helpers.removerMascara(form.cnpj);
    let result = [];
    if (!form.id) result = ApiService.post(`Usuario`, { ...form });
    else result = ApiService.put(`Usuario`, { ...form });
    return result;
  },
  excluir(id) {
    return ApiService.delete(`Usuario?id=${id}`);
  },
  alterarSenha(form) {
    return ApiService.put(`Usuario/alterar-senha`, { ...form });
  },
  editarPerfis(form) {
    return ApiService.put(`Usuario/associar-perfis`, { ...form });
  },
  esqueceuSenha(form) {
    return ApiService.post(`Usuario/solicitar-reset-senha?email=${form.email}`, { ...form });
  },
  resetarSenha(form) {
    return ApiService.put(`Usuario/reset-senha`, { ...form });
  },
  async usuarioDropdown() {
    let data = await ApiService.get(`Usuario/dropdown`);
    
    let itens = data.data.data.usuarios;
    
    let retorno = [];
    
    for (let i = 0; i < itens.length; i++) {
      if (itens[i].nome != "ConcurrencyStamp")
      retorno.push({
        value: itens[i].id,
        text: itens[i].nome,
      });
    }

    return retorno;
  },

  pegarTermos() {
    return ApiService.get(`TermosServico`);
  },

  me() {
    return ApiService.get(`Usuario/usuario-logado`);
  },
  
  /*listarAprovacao(porPagina = 0, pagina = 0) {
    return ApiService.get(`Usuario/aprovar/?TamanhoDaPagina=${porPagina}&NumeroDaPagina=${pagina}`);
  },
  
  registrarAprovacao(form) {
    return ApiService.post(`AprovacaoUsuario`, { ...form });
  }
  mudarAcesso(form) {
    return ApiService.put(`Usuario/aprovar`, { ...form });
  },
  removerAcesso(form) {
    return ApiService.put(`Usuario/reprovar?id=${form.id}`);
  },*/
  buscarPermissoes(id) {
    return ApiService.get(`Usuario/permissao-campos?usuarioId=${id}`);
  },
  salvarPermissoes(form) {
    return ApiService.put(`Usuario/permissao-campos`, form);
  },
  novoUsuario(form) {
    return ApiService.post(`Pessoa/email-criacao-usuario`, form);
  },
  criarViaEmail(form) {
    return ApiService.post(`Usuario/criar-usuario-pessoa`, form);
  }
  
};

export default UsuarioService;
